import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductCard from '../components/ProductCard';
import LoadingSpinner from '../components/LoadingSpinner';
import { Separator } from '../components/ui/separator';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProductosPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/products`);
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#EFE1C4]">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="bg-[#EFE1C4]" data-testid="productos-page">
      {/* Header */}
      <section className="py-16 md:py-24 bg-[#F5EBD4]">
        <div className="container-brand">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl text-[#1E1E1E] mb-4">
              NUESTROS PRODUCTOS
            </h1>
            <p className="font-body text-base md:text-lg text-[#4E3A21] opacity-80">
              Embutidos y quesos artesanales, elaborados con paciencia y respeto por la materia prima
            </p>
          </div>
        </div>
      </section>

      <Separator className="separator-gold" />

      {/* Products Grid */}
      <section className="section-padding">
        <div className="container-brand">
          {products.length > 0 ? (
            <div className="product-grid">
              {products.map((product) => (
                <ProductCard key={product.slug} product={product} />
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="font-body text-[#4E3A21]">No hay productos disponibles en este momento</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-16 bg-[#F5EBD4]">
        <div className="container-brand">
          <div className="max-w-2xl mx-auto text-center">
            <p className="font-body text-base text-[#1E1E1E] mb-4">
              ¿Querés saber más sobre algún producto?
            </p>
            <p className="font-body text-sm text-[#4E3A21] opacity-80">
              Contactanos y te asesoramos sobre disponibilidad y pedidos
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductosPage;
